import React from 'react';
import PropTypes from 'prop-types';
import onEULabelsClick from '../sidebar/actions/on_eu_labels_click';

function ProductEuLabels(props) {
  const { labelFuelEfficiency, labelWetGrip, labelNoise } = props;

  let euLabelsElem = '';
  if (labelFuelEfficiency || labelWetGrip || labelNoise) {
    euLabelsElem = (
      <div
        id="eu-labels-container"
        className="product-details__cell product-details__text"
        style={{ fontSize: '12px' }}
        onClick={() => onEULabelsClick(props)}
      >
        <div className="eu-labels" style={{ marginTop: '20px' }}>
          {labelFuelEfficiency ? (
            <div>
              <span className="icon icon-middle icon-eu-label-fuel"></span>
              <span className={`icon icon-middle icon-eu-label-shape icon-eu-label-fuel-${labelFuelEfficiency}`}></span>
              <span className={`icon-description`}>{labelFuelEfficiency}</span>
            </div>
          ) : (
            ''
          )}
          {labelWetGrip ? (
            <div>
              <span className="icon icon-middle icon-eu-label-wet-grip"></span>
              <span className={`icon icon-middle icon-eu-label-shape icon-eu-label-wet-grip-${labelWetGrip}`}></span>
              <span className={`icon-description`}>{labelWetGrip}</span>
            </div>
          ) : (
            ''
          )}
          {labelNoise ? (
            <div>
              <span className="icon icon-middle icon-eu-label-noise"></span>
              <span className={`icon icon-middle icon-eu-label-shape`}></span>
              <span className="icon-description">
                {labelNoise} <span>{labelNoise <= 71 ? 'A' : labelNoise <= 77 ? 'B' : 'C'}</span>
              </span>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }

  return <>{euLabelsElem}</>;
}

ProductEuLabels.defaultProps = {
  labelFuelEfficiency: '',
  labelWetGrip: '',
  labelNoise: '',
};

export default ProductEuLabels;
